import { Component, VNode, h } from '@stencil/core';

/**
 * @tag `<ads-card-content>`
 * @hidden
 */
@Component({
  tag: 'ads-card-content',
  styleUrl: 'ads-card-content.scss',
  shadow: true,
})
export class AdsCardContent {
  protected render(): VNode {
    return (
      <span class="c-card-content">
        <slot />
      </span>
    ) as VNode;
  }
}
